import CountryAnalytics from '@/modules/countryАnalytics/CountryAnalytics.vue';

export const routes = [
  {
    path: '/Country',
    name: 'CountryAnalytics',
    component: CountryAnalytics,
  },
  {
    path: '/worldtrade/tecworld',
    name: 'TecWorldView',
    component: () => import('../TecWorldView.vue'),
  },
  {
    path: '/worldtrade/foreigntradeturnoverworld',
    name: 'ForeignTradeTurnoverWorldView',
    component: () => import('../ForeignTradeTurnoverWorldView.vue'),
  },
];
